// extracted by mini-css-extract-plugin
module.exports = {"CreateEvent":"CreateEvent_CreateEvent___fQOv"};